<form [formGroup]="getOrderTimeForm">

  <mat-dialog-content>
    <p>
      {{message}}
    </p>
  </mat-dialog-content>

  <mat-radio-group formControlName="timeValue" fxLayoutAlign="space-between stretch" fxLayout="column">
    <mat-radio-button [checked]="time == timeValue" *ngFor="let time of timesList" class="radio-button" value="{{time}}">{{time}}</mat-radio-button>
  </mat-radio-group>

  <mat-dialog-actions align="center">
    <button mat-raised-button (click)="onConfirmClick()" color="primary" tabindex="1">{{confirmButtonText}}</button>
    <button mat-raised-button mat-dialog-close tabindex="-1">{{cancelButtonText}}</button>
  </mat-dialog-actions>

</form>
